// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'search-table';

export const Component = () => (
  <path d='m18.152 22.888.718-.67-6.274-6.274c.767-.91 1.15-1.964 1.15-3.065 0-1.39-.48-2.538-1.437-3.496-.958-.958-2.107-1.437-3.496-1.437-1.341 0-2.491.479-3.449 1.437-.958.958-1.437 2.107-1.437 3.496 0 1.34.48 2.49 1.437 3.448.958.958 2.107 1.437 3.449 1.437 1.197 0 2.203-.383 3.113-1.101l6.226 6.225ZM6.034 15.656c-.766-.766-1.149-1.676-1.149-2.778 0-1.101.383-2.012 1.15-2.778.766-.766 1.676-1.15 2.777-1.15 1.102 0 2.012.384 2.779 1.15.766.766 1.149 1.677 1.149 2.778 0 1.102-.383 2.012-1.15 2.778-.766.767-1.676 1.15-2.777 1.15-1.102 0-2.012-.383-2.779-1.15ZM24.521 1.001H0v10.823h3.017c.048-.335.144-.67.288-1.005H.958V2.006h6.897v4.98c.43-.047.766-.095.957-.095V2.005h6.897v8.813h-1.34c.143.431.191.766.239 1.005h9.914V1Zm-.958 1.006v8.813h-6.897V2.007h6.897Z' />
);

export const viewBox = '0 0 25 25';
